import { Flex, Tag, Text } from "@chakra-ui/react";

interface RateTagProps {
	label: string;
	rate: string;
}

export const RateTag = ({ label, rate }: RateTagProps) => {
	return (
		<Flex gap="2" align="center" justify="space-between">
			<Text fontFamily="Kalnia Variable">{label}</Text>

			<Tag
				py="1"
				rounded="3"
				w="fit-content"
				bg="brand.light"
				color="brand.dark"
				border="solid 1.5px"
				borderColor="brand.dark"
			>
				{rate}
			</Tag>
		</Flex>
	);
};
